import { useEffect } from 'react';
import { loadWalletInfoAsync } from '../../data-layer/cpa/actions';
import { selectWalletInfo } from '../../data-layer/cpa/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import { canShowCpa } from '../../utils/accessService';
import { useExperimentFlag } from '../../utils/useExperimentFlag';
import { useBusinessModel } from '../business/useBusinessModel';
import { useCurrentUser } from './useCurrentUser';

export const useCpaPromoBalance = () => {
    const dispatch = useDispatch();
    const currentUser = useCurrentUser();
    const businessId = currentUser?.profile?.publicId || '';
    const business = useBusinessModel({ businessId });
    const cpaEnabled =
        Number(useExperimentFlag('cpa_enabled')) === 1 && canShowCpa(currentUser, business);
    const walletInfo = useSelector(selectWalletInfo);

    useEffect(() => {
        if (cpaEnabled && !walletInfo) {
            dispatch(loadWalletInfoAsync());
        }
    }, [dispatch, cpaEnabled, walletInfo]);

    return walletInfo?.balance;
};
